export default __webpack_public_path__ + "static/media/Kawasaki1.575763ee.jpg";